export const contexto = state => state.contexto;
export const snackbar = state => state.snackbar;
export const notification = state => state.notification;
export const tipo_agenda = state => state.tipo_agenda;
export const instituicao_atual = state => (state.contexto || {}).instituicao;
export const filtro_venda = state => state.filtro_venda;
export const filtro_compra = state => state.filtro_compra;
export const localizacao = state => state.localizacao;

export const items = state => state.items.map(item => {
  const obj = {
    ...item,
    quantidade_total: 3,
    quantidade_disponivel: 0,
    quantidade_usada: 0
  };
  if (item.lotes)
    (item.lotes || []).forEach(lote => {
      lote.quantidade_disponivel = 0;
      lote.quantidade_total = 0;
      lote.quantidade_usada = 0;
      (lote.movimentacoes || []).forEach(movimentacao => {
        lote.quantidade_disponivel += movimentacao.quantidade * (!movimentacao.entrada ? -1 : 1);
        lote.quantidade_total += movimentacao.quantidade * (!movimentacao.entrada || movimentacao.estorno ? 0 : 1);
        lote.quantidade_usada += movimentacao.quantidade * (!movimentacao.entrada ? 1 : (movimentacao.estorno ? -1 : 0));
      });
      obj.quantidade_disponivel += lote.quantidade_disponivel;
      obj.quantidade_usada += lote.quantidade_usada;
      obj.quantidade_total += lote.quantidade_total;
    });

  return obj;
});
